import React, { FC, useRef, useState } from "react";
import { ChatServerButton, ChatServerList, ChatServerListItem } from "../../xapp/ChatServerMessage";
import { CarouselItem } from "../CarouselItem";
import { ChevronLeft } from "../ChevronLeft";
import { ChevronRight } from "../ChevronRight";
import "./Carousel.scss";
import { OpenUrlCallback } from "../../hooks/useOpenUrlCallback";

export interface CarouselProps {
    readonly list: ChatServerList;
    onButtonClick(button: ChatServerButton): void;
    onExecute(text: string, token?: string): void;
    onOpenUrl: OpenUrlCallback;
}

const Carousel: FC<CarouselProps> = (props) => {
    const listRef = useRef<HTMLDivElement>(null);
    const [visibleIndex, setSetVisibleIndex] = useState(0);

    function scrollMe(direction: number): void {
        const scrollArea = listRef.current;

        if (scrollArea) {
            const items = scrollArea.getElementsByClassName("xappw-carousel-items__item");
            const noOfItems = items.length;

            let newVisibleIndex = visibleIndex;

            // check the boundaries
            if (direction === 1) {
                if (visibleIndex < noOfItems - 1) {
                    newVisibleIndex++;
                }
            } else {
                if (visibleIndex > 0) {
                    newVisibleIndex--;
                }
            }

            let leftOffset = 0;

            // tslint:disable-next-line:prefer-for-of
            for (let index = 0; index < items.length; index++) {
                if (index === newVisibleIndex) {
                    break;
                }
                leftOffset += items.item(index)?.clientWidth ?? 0;
            }

            scrollArea.scrollLeft = leftOffset;

            setSetVisibleIndex(newVisibleIndex);
        }
    }

    const hasOnlyOneItem = props.list.items.length === 1;

    const hasImage = props.list.items.some((item) => item.imageUrl);

    const listItems = props.list.items.map((item: ChatServerListItem, itemIndex: number) => {
        return (
            <div className="xappw-carousel-items__item" key={`item-key-${itemIndex}`}>
                <CarouselItem
                    item={item}
                    emptyImageVisible={hasImage}
                    onExecute={props.onExecute}
                    onButtonClick={props.onButtonClick}
                    onOpenUrl={props.onOpenUrl}
                />
            </div>
        );
    });

    return (
        <div className="xappw-carousel">
            {!hasOnlyOneItem && (
                <div className="xappw-carousel__prev">
                    <ChevronLeft onClick={() => scrollMe(-1)} />
                </div>
            )}
            <div ref={listRef} className={`xappw-carousel-items ${hasOnlyOneItem ? "xappw-carousel-items--one-item" : ""}`}>
                {listItems}
            </div>
            {!hasOnlyOneItem && (
                <div className="xappw-carousel__next">
                    <ChevronRight onClick={() => scrollMe(1)} />
                </div>
            )}
        </div>
    );
};

export default Carousel;
